// Auto-focuses its element on connect.
// Useful for elements that appear after a Turbo frame load (e.g. confirmation buttons).
//
// Usage:
//   <a data-controller="autofocus" href="...">Confirm</a>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.focus()
  }
}
